module.exports = __webpack_public_path__ + "static/notion-19b0f81386812ed2f2f3a7aea202935f.svg";